import { Grid, Typography } from '@mui/material'
import s from './LocationSummary.modules.scss'
import { Capsule } from 'components/core-ui/Capsule'
import { Button, IconButton } from '@fullscreendigital/carrefour-dex-fe'
import { AddActionIcon } from 'icons'

interface LocationSummaryProps {
  parentName: string
  name: string
  locationUnitTypeName: string
  active: boolean
  childrenCount: number
}

const LocationSummary = (props: LocationSummaryProps) => {
  const { parentName, name, locationUnitTypeName, active, childrenCount } = props

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={s.name} fontWeight={700}>
          {name}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item mt={1} mr={1}>
            <Capsule label="Type" value={locationUnitTypeName} />
          </Grid>
          <Grid item mt={1} mr={1}>
            <Capsule label="Active" value={`${active ? 'Yes' : 'No'}`} />
          </Grid>
          <Grid item mt={1} mr={1}>
            <Capsule
              label="Parent"
              value={parentName}
              valueColor={'#004f9b'}
              labelColor={'#d9e5f0'}
            />
          </Grid>
          <Grid item mt={1} mr={1}>
            <Capsule label="Children" value={childrenCount} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default LocationSummary
